import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CTooltip } from '@coreui/react';

const SafeTooltip = ({ content, children, timeout, ...props }) => {
  const [visible, setVisible] = useState(false);

  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  const clearTimers = () => {
    if (showTimerRef.current) clearTimeout(showTimerRef.current);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
  };

  const handleMouseEnter = () => {
    clearTimers();

    showTimerRef.current = setTimeout(() => {
      setVisible(true);

      hideTimerRef.current = setTimeout(() => {
        setVisible(false);
      }, timeout);
    }, 150);
  };

  const handleMouseLeave = () => {
    clearTimers();
    setVisible(false);
  };

  const handleClick = () => {
    clearTimers();
    setVisible(false);
  };

  useEffect(() => {
    return () => clearTimers();
  }, []);

  const child = React.Children.only(children);

  const trigger = React.cloneElement(child, {
    onMouseEnter: (e) => {
      handleMouseEnter();
      if (child.props.onMouseEnter) child.props.onMouseEnter(e);
    },
    onMouseLeave: (e) => {
      handleMouseLeave();
      if (child.props.onMouseLeave) child.props.onMouseLeave(e);
    },
    onClick: (e) => {
      handleClick();
      if (child.props.onClick) child.props.onClick(e);
    },
  });

  return (
    <CTooltip content={content} visible={visible} {...props}>
      {trigger}
    </CTooltip>
  );
};

SafeTooltip.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.element.isRequired,
  timeout: PropTypes.number,
};

SafeTooltip.defaultProps = {
  timeout: 4000,
};

export default SafeTooltip;